/**
 * TODO: in the back-end the notifications are been changed
 *
 * Create method: the create method is now called in BoardController V2
 * Update method: the update method is now called in UserController V1
 * All serch methods are now called in UserController V1
 */
import APIClient from '@/shared/http/clients/api'

const resourceName = 'card'
const APICore = process.env.APIBaseURLCore

const searchNotificationsUser = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user`, config)
const searchNotificationsUserViewdTrue = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?visualizado=true`, config)
const searchNotificationsUserViewdFalse = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?visualizado=false`, config)
const searchNotificationsUserCustom = (filter, config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?${filter}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/notifications`, data, config)
const Update = (id, config = {}) => APIClient.put(`${APICore}/${resourceName}/notifications/${id}`, config)

const NotificationsCardRepository = {
  searchNotificationsUser,
  Create,
  Update,
  searchNotificationsUserViewdTrue,
  searchNotificationsUserViewdFalse,
  searchNotificationsUserCustom
}

export default NotificationsCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/notificationscard.js